(function () {
    if (typeof window.checkDeliverythreshold !== "function") {
        return;
    }

    const checkDeliverythreshold = window.checkDeliverythreshold;

    window.checkDeliverythreshold = function () {
        const progress = document.querySelector(".cart-progress");

        if (
            !progress ||
            !progress.querySelector(".label span") ||
            !progress.querySelector(".progress-marker")
        ) {
            return;
        }

        return checkDeliverythreshold.apply(this, arguments);
    };
})();
